import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { LoaderSpinner } from '@dreryk/react-components';

import { VisitDocumentContextProvider } from '../../../common/visitDocument/VisitDocumentContext';

import { useMedicalLeaveDraft, useMedicalLeaveDraftQuery } from './medicalLeave.hooks';
import { MedicalLeaveForm } from './MedicalLeaveForm';

type MedicalLeaveTabProps = {
   readonly visit: Visit;
};

export const MedicalLeaveTab = (props: MedicalLeaveTabProps): JSX.Element => {
   const { visit } = props;
   const { data: medicalLeave, loading: medicalLeaveLoading } = useMedicalLeaveDraftQuery(visit.id);
   const medicalLeaveDraft = useMedicalLeaveDraft(medicalLeave);

   if (medicalLeaveLoading) {
      return <LoaderSpinner />;
   }

   return (
      <VisitDocumentContextProvider externalId={medicalLeaveDraft?.externalId} visitId={props.visit.id}>
         <MedicalLeaveForm visit={visit} draft={medicalLeaveDraft} />
      </VisitDocumentContextProvider>
   );
};
